// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--1dac3","paragraph":"styles-module--paragraph--2R5OZ","inlineLink":"styles-module--inlineLink--1GEfu"};